import React, { useRef, useEffect, useState } from 'react';
import Chart from 'chart.js/auto';
import { BarData } from '../__chart__data/index';

interface IProps {
  activeBar?: number;
  setActiveBar?: any;
  totalValue?: any;
  dataValues?: any;
}

const BarChart: React.FC<IProps> = ({
  totalValue,
  activeBar,
  setActiveBar,
  dataValues,
}) => {
  const chartRef = useRef<any>(null);
  const [myChart, setMyChart] = useState<any>(null);
  const adjustedValues = dataValues.map((value: any) => {
    return Number.isNaN((value / totalValue) * totalValue)
      ? 0
      : (value / totalValue) * totalValue;
  });

  const remainingValues = adjustedValues.map((value: any) =>
    Math.max(...adjustedValues) === value
      ? 0
      : (totalValue ? Math.max(...adjustedValues) : 1) - value
  );

  const initialBackgroundColor = Array(dataValues.length).fill('black');
  initialBackgroundColor[0] = 'blue';
  const lineChartData = {
    labels: BarData?.map((e) => e?.label),
    datasets: [
      {
        label: 'Actual',
        data: adjustedValues,
        backgroundColor: initialBackgroundColor,
        barThickness: 20,
        barPercentage: 0.25,
      },
      {
        label: 'Remaining',
        data: remainingValues,
        backgroundColor: '#F1F0F6',
        barThickness: 20,
        barPercentage: 0.25,
      },
    ],
  };
  const [newChartData, setNewChartData] = useState(lineChartData);

  useEffect(() => {
    const config: any = {
      type: 'bar',
      data: newChartData,
      options: {
        onClick: (event: any, activeElements: any) => {
          if (activeElements.length > 0) {
            const chartElement = activeElements[0];
            const datasetIndex = chartElement.datasetIndex;
            const dataIndex = chartElement.index;

            // Check if the clicked bar is the active bar
            if (dataIndex === activeBar) {
              return; // Do nothing if the active bar is clicked
            }

            // if (datasetIndex === 1) {
            const updatedChartData: any = { ...lineChartData };
            updatedChartData.datasets[0].backgroundColor = Array(
              dataValues.length
            ).fill('black');

            updatedChartData.datasets[0].backgroundColor[dataIndex] = 'blue';
            setNewChartData(updatedChartData);
            // }

            setActiveBar(dataIndex);
          }
        },

        indexAxis: 'y',
        elements: {
          bar: {
            borderWidth: 0,
          },
        },
        responsive: true,
        onHover: (event: any, chartElement: any) => {
          event.native.target.style.cursor = chartElement[0]
            ? 'pointer'
            : 'default';
        },

        plugins: {
          tooltip: {
            enabled: false,
          },
          legend: {
            display: false,
            position: 'right',
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            beginAtZero: true,
            stacked: true,
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              display: false,
              font: {
                size: 14,
              },
            },
          },
          y: {
            beginAtZero: true,
            stacked: true,
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              display: true,
              font: {
                size: 14,
              },
            },
          },
          ticks: {
            display: false,
          },
        },
      },
      plugins: {
        afterDraw: (chart: any) => {
          var ctx = chart.ctx;
          chart.data.datasets.forEach((dataset: any, i: any) => {
            var meta = chart.getDatasetMeta(i);
            meta.data.forEach((bar: any, index: any) => {
              var data = dataset.data[index];
              ctx.fillText(data, bar.x, bar.y - 5);
            });
          });
        },
      },
    };

    const initializeChart = () => {
      if (chartRef.current) {
        const ctx = chartRef.current.getContext('2d');
        const newChart: any = new Chart(ctx, config);
        setMyChart(newChart);
      }
    };

    if (myChart) {
      myChart.destroy();
    }

    setTimeout(initializeChart, 0);
  }, [newChartData]);

  return (
    <>
      <canvas id={'myChart'} ref={chartRef} style={{ maxHeight: '500px' }} />
    </>
  );
};

export default BarChart;
